import {
  Box,
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';
import { FormularioComunidades } from 'interfaces/formularioComunidades.interface';

import { IComunidadesRuraisTradicionais } from 'stores/forms/comunidades_rurais_tradicionais';

interface ViewStep2Props {
  formData: IComunidadesRuraisTradicionais & FormularioComunidades;
}

export const ViewStep2: React.FC<ViewStep2Props> = ({
  formData,
}) => {
  const formatBooleanValue = (value: boolean | null) => {
    if (value === null || value === undefined) return '';
    return value ? 'Sim' : 'Não';
  };

  const escolas = formData.escolas;

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        variant='h5'
        gutterBottom
        sx={{ fontWeight: 'bold', mb: 4 }}
      >
        Infraestrutura e Serviços
      </Typography>

      {/* Serviços Básicos */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui energia elétrica?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_energia_eletrica)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui abastecimento de água potável?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_saneamento_basico)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui coleta seletiva de resíduos?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.coleta_de_lixo)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Recebeu manutenção das estradas no último ano?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.recebeu_manutencao_das_estradas_no_ultimo_ano)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      {/* Educação */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui escolas?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_escolas)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui esgotamento sanitário?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_esgotamento_sanitario)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui uma cultura de manejo do solo para evitar desertificação?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_cultura_manejo_solo)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            É perceptível a degradação do solo?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.tem_degradacao_solo)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            É perceptível o assoreamento na rede fluvial?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.tem_assoreamento_fluvial)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui oferta de transporte escolar para os estudantes?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_oferta_de_transporte_escolar_para_os_estudantes)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      {/* Detalhes das Escolas */}
      {formData.possui_escolas === true && escolas.length > 0 && (
        <Box sx={{ mb: 4 }}>
          <Card
            sx={{
              mt: 2,
              mb: 3,
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: '1px solid #e0e0e0'
            }}
          >
            <CardContent sx={{ p: 3 }}>
              {/* Cabeçalho da seção com ícone */}
              <Box display="flex" alignItems="center" mb={3}>
                <SchoolIcon sx={{ mr: 2, color: 'primary.main', fontSize: 28 }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Escolas Cadastradas
                </Typography>
                <Box ml="auto">
                  <Typography variant="body2" color="text.secondary">
                    {escolas.length} {escolas.length === 1 ? 'escola' : 'escolas'} cadastrada(s)
                  </Typography>
                </Box>
              </Box>

              {/* Lista de escolas cadastradas */}
              {escolas.map((escola, index) => (
                <Card
                  key={index}
                  sx={{
                    mb: 2,
                    borderRadius: '8px',
                    backgroundColor: '#ffffff',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0',
                    '&:hover': {
                      boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                    }
                  }}
                >
                  <CardContent sx={{ p: 2 }}>
                    {/* Cabeçalho do card da escola */}
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'primary.main' }}>
                        Escola {index + 1}
                      </Typography>
                    </Box>

                    {/* Informações da escola */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1 }}>
                          Nome da Escola:
                        </Typography>
                        <TextField
                          fullWidth
                          value={escola.nome || 'Não informado'}
                          InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1 }}>
                          Jurisdição:
                        </Typography>
                        <TextField
                          fullWidth
                          value={escola.jurisdicao || 'Não informado'}
                          InputProps={{
                            readOnly: true,
                            sx: { backgroundColor: '#f5f5f5' },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              ))}

              {/* Mensagem quando não há escolas (caso de fallback) */}
              {escolas.length === 0 && (
                <Box
                  textAlign="center"
                  py={4}
                  sx={{
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    border: '2px dashed #dee2e6'
                  }}
                >
                  <SchoolIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                  <Typography variant="body1" color="text.secondary" mb={1}>
                    Nenhuma escola cadastrada
                  </Typography>
                  <Typography variant="body2" color="text.disabled">
                    Esta comunidade não possui escolas registradas
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      )}

      {/* Saúde */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Possui unidade de saúde?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.possui_unidade_de_saude)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>

        <Grid item xs={6}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Recebe agentes de saúde do município?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.recebeu_agentes_de_saude_do_municipio)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12}>
          <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
            Tem acesso à internet?
          </Typography>
          <TextField
            fullWidth
            value={formatBooleanValue(formData.tem_acesso_internet)}
            InputProps={{
              readOnly: true,
              sx: { backgroundColor: '#f5f5f5' },
            }}
          />
        </Grid>
      </Grid>

    </Box>
  );
};
